/* Cosmic Atelier — Shazory Creator Studio */
/* SEO H1 is now hardcoded in sections/cosmic-atelier.liquid. JS injection workaround removed. */
(function(){
  // Particles
  var wrap = document.getElementById('caParticles');
  if(wrap){
    var count = window.innerWidth < 640 ? 10 : 22;
    for(var i=0;i<count;i++){
      var p = document.createElement('div');
      p.className = 'ca-particle';
      p.style.left = (Math.random()*100)+'%';
      p.style.animationDelay = (Math.random()*12)+'s';
      p.style.animationDuration = (10+Math.random()*12)+'s';
      p.style.opacity = (0.25+Math.random()*0.35);
      var s = (2+Math.random()*3)+'px';
      p.style.width = s; p.style.height = s;
      wrap.appendChild(p);
    }
  }

  // Scroll reveal
  var elements = document.querySelectorAll('.ca-reveal');
  if(!('IntersectionObserver' in window)){
    elements.forEach(function(el){el.classList.add('in')});
  } else {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    elements.forEach(function(el){io.observe(el)});
  }

  // Watch grid sequential ripple
  var grid = document.getElementById('caWatchGrid');
  if(grid){
    var tiles = grid.querySelectorAll('.ca-watch-tile');
    var idx = 0, running = false, interval;
    function step(){
      tiles.forEach(function(t){t.classList.remove('active')});
      if(tiles[idx]) tiles[idx].classList.add('active');
      idx = (idx+1) % tiles.length;
    }
    function start(){
      if(running) return;
      running = true; step();
      interval = setInterval(step, 1400);
    }
    function stop(){
      running = false;
      clearInterval(interval);
    }
    if('IntersectionObserver' in window){
      var gio = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting) start(); else stop();
        });
      }, { threshold: 0.3 });
      gio.observe(grid);
    } else {
      start();
    }
  }
})();
